<template>
  <validation-observer
    vid="stepQuestionsForm"
    ref="stepQuestionsForm"
    tag="div"
    novalidate
  >
    <vvs-control-wrapper label="2. Sizi Tanıyalım"></vvs-control-wrapper>

    <vvs-address
      label="Adres Bilgilerinizi Giriniz"
      description="Başvurunuzu tamamlayabilmeniz için adres bilgileriniz eksiksiz doldurunuz."
      :address.sync="step.location"
      normal-label
    ></vvs-address>

    <vvs-checkbox
      name="Hizmet Bölgeleriniz"
      label="Hizmet Bölgeleriniz"
      :description="
        `${
          step.serviceRegions.length > 0
            ? `${step.serviceRegions.length} adet hizmet bölgesi seçtiniz.<br>`
            : ''
        }Eğer bütün bölgelere hizmet veriyorsanız bir seçim yapmak zorunda değilsiniz.`
      "
      :options="serviceRegionCities"
      v-model="step.serviceRegions"
      show-more-items-limit="12"
      show-more-items-scroll-offset="-90"
      show-more-items-height="170px"
      multiple
      small
      normal-label
    ></vvs-checkbox>

    <vvs-questions
      :questions.sync="questions"
      :form-questions="step.questions"
      :static-questions="staticQuestions"
      hide-question-number
      normal-label
    ></vvs-questions>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';
import staticQuestions from '@/data/carrier-questions';
import serviceRegionCities from '@/data/service-region-cities';

export default {
  name: 'StepQuestions',
  mixins: [stepsMixin],
  data() {
    return {
      questions: [],
      staticQuestions: staticQuestions,
      serviceRegionCities: serviceRegionCities,
    };
  },
  watch: {
    questions: {
      handler() {
        if (this.questions.length > 0 && this.step.questions.length === 0)
          this.step.questions = [...this.questions];
      },
      deep: true,
    },
  },
};
</script>
